import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Tracker } from '@reverbdotcom/discovery-ui';

class SocialLink extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    icon: PropTypes.string,
  };

  icon = () => this.props.icon || this.props.type;

  trackClick = (e) => {
    Tracker.trackInteraction({
      name: 'socialLink',
      url: e.currentTarget.href,
      context: { type: this.props.type },
    });
  };

  render() {
    return (
      <a href={this.props.link} target="_blank" rel="noopener noreferrer" onClick={this.trackClick}>
        <span className={`share-${this.props.type} no-icon-bg`}>
          <span className={`fa fa-${this.icon()}`} />
        </span>
      </a>
    );
  }
}

export default SocialLink;



// WEBPACK FOOTER //
// ./javascripts/components/shared/social_link.jsx